import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"


export const isLoadingUserSettingAcrissData = signal(true)
export const isLoadingUserSettingCategoryData = signal(true)
export const userSettingAcrissData = signal([])
export const userSettingCategoryData = signal([])
export const userSettingAcrissFormData = signal({})
export const userSettingCategoryFormData = signal({})

// Computed
export const isLoadingUserSettingsAcrissCategoryData = computed(() => isLoadingUserSettingAcrissData.value || isLoadingUserSettingCategoryData.value)
export const isOpenUserSettingsAcrissDrawer = computed(() => !isEmpty(userSettingAcrissFormData.value))
export const isOpenUserSettingsCategoryDrawer = computed(() => !isEmpty(userSettingCategoryFormData.value))
export const isEditUserSettingsAcrissDrawer = computed(() => userSettingAcrissFormData.value?.id !== null)
export const isEditUserSettingsCategoryDrawer = computed(() => userSettingCategoryFormData.value?.id !== null)

// Functions
export const clearUserSettingAcrissCategorySignals = () => batch(() => {
	isLoadingUserSettingAcrissData.value = true
	isLoadingUserSettingCategoryData.value = true
	userSettingAcrissData.value = []
	userSettingAcrissData.value = []
	userSettingAcrissFormData.value = {}
	userSettingCategoryFormData.value = {}
})